import { LienHolderAddressType } from './types';

export const transformLienholderAddress = (data: LienHolderAddressType) => {
  return Object.entries(data).reduce(
    ({ address, isValid }, [key, value]) => {
      // if the key is not addressLine2 and there is no value then address data is invalid
      if (key !== 'addressLine2' && !value) {
        isValid = false;
      }

      return {
        address: {
          ...address,
          // reset any null values to blank string or use existing value
          [key]: value === null ? '' : value,
        },
        isValid,
      };
    },
    {
      address: {},
      isValid: true,
    }
  );
};
